/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getUserTable = params => {
  return axios.post(`${base}/query_user`, params)
}
// 获取用户编辑详情
export const getUserDetail_ = params => {
  return axios.get(`${base}/user_${params.userid}`, {params})
}
// 获取用户详情
export const getUserDetail = id => {
  return axios.get(`${base}/userdetail_${id}`)
}
export const getUserRelatedOptions = params => {
  return axios.get(`${base}/userrelated_options`)
}
export const getQueryCustomerService = params => {
  return axios.post(`${base}/query_customerservice`, params)
}
export const addCustomerService = params => {
  return axios.post(`${base}/add_customerservice`, params)
}
export const modifyCustomerService = params => {
  return axios.post(`${base}/modify_customerservice`, params)
}
export const searchCustomerService = params => {
  return axios.post(`${base}/search_customer_service`, params)
}
export const getUserDevice = userid => {
  return axios.get(`${base}/userdevice_${userid}`)
}
export const getUserOperate = userid => {
  return axios.get(`${base}/opinfo_user_${userid}`)
}
export const getUserAccount = userid => {
  return axios.get(`${base}/useraccount_${userid}`)
}
export const getUserLog = userid => {
  return axios.get(`${base}/adminlog_user_${userid}`)
}
export const getUserWorkInfoLog = params => {
  return axios.post(`${base}/get_workinfo_log_${params.userid}`, params)
}
export const getUserCredit = userid => {
  return axios.get(`${base}/usercredit_${userid}`)
}
export const getCreditList = params => {
  return axios.post(`${base}/creditflow_user_${params.userid}`, params)
}
export const getPointList = params => {
  return axios.post(`${base}/pointflow_user_${params.userid}`, params)
}
export const getUserPoints = id => {
  return axios.get(`${base}/userpoints_${id}`)
}
export const getMasTable = params => {
  return axios.post(`${base}/query_user_massmsg`, params)
}
export const getMarketInfo = params => {
  return axios.post(`${base}/query_market`, params)
}
export const uploadUserMasImg = params => {
  return axios.post(`${base}/massmsg_uploadfile`, params)
}
export const addUserMas = params => {
  return axios.post(`${base}/add_user_massmsg`, params)
}

export const getAreaList = id => {
  return axios.get(`${base}/arealist_` + id)
}
export const getTagInfo = params => {
  return axios.post(`${base}/query_tag`, params)
}
export const getUserList = params => {
  return axios.post(`${base}/query_user`, params)
}
export const getUserTagName = params => {
  return axios.post(`${base}/get_user_tag_name`, params)
}
export const getUserMarketName = params => {
  return axios.post(`${base}/get_user_market_name`, params)
}
export const getUserAbilitiesName = params => {
  return axios.post(`${base}/get_user_abilities_name`, params)
}
export const getUserAttributes = params => {
  return axios.post(`${base}/get_user_attributes_name`, params)
}
export const updateUser = params => {
  return axios.post(`${base}/edit_user_` + params.userid, params)
}
export const uploadUserImg = params => {
  return axios.post(`${base}/user_uploadfile`, params)
}
export const adminDirectUploadFilesApi = params => {
  return axios.post(`${base}/admin_direct_upload_files`, params)
}
export const getUserDetailOption = id => {
  return axios.get(`${base}/get_user_detail_option_` + id)
}
export const getUser = id => {
  return axios.get(`${base}/user_` + id)
}
export const createUser = params => {
  return axios.post(`${base}/create_user`, params)
}
export const freezeUser = params => {
  return axios.post(`${base}/freeze_user_` + params.userid, params)
}
export const unFreezeUser = id => {
  return axios.post(`${base}/unfreeze_user_` + id)
}
export const unBoundUserWeixin = ({id}) => {
  return axios.post(`${base}/unbind_user_weixin_` + id)
}
export const queryUser = params => {
  return axios.post(`${base}/user/query`, params)
}
export const queryDeletedUsers = params => {
  return axios.post(`${base}/query_deleted_users`, params)
}
export const queryDevices = params => {
  return axios.post(`${base}/device/query`, params)
}
export const exportDeviceDetail = params => {
  return axios.post(`${base}/device/export_detail`, params)
}
export const getDeviceDetail = params => {
  return axios.get(`${base}/device/get_${params.id}`, params)
}
export const getDeviceStats = params => {
  return axios.post(`${base}/device/stats`, params)
}
export const queryUserDevices = params => {
  return axios.post(`${base}/device/query_user`, params || {})
}
export const removeBlacklistCellphone = params => {
  return axios.post(`${base}/remove_blacklist_cellphone`, params)
}
export const exportUser = params => {
  return axios.post(`${base}/user_export`, params)
}
export const batchExportUserInfo = params => {
  return axios.post(`${base}/batch_export_user_info`, params)
}
export const getUserAccountList = params => {
  return axios.post(`${base}/query_user_balance`, params)
}
export const getUserPointsList = params => {
  return axios.post(`${base}/query_points`, params)
}
export const exportCurrentWithdrawUser = params => {
  return axios.post(`${base}/export_current_withdraw`, params)
}

export const updateUserWorkinfo = params => {
  return axios.post(`${base}/edit_user_workinfo_${params.id}`, params)
}
export const updateUserPhone = params => {
  return axios.post(`${base}/edit_user_phone_${params.id}`, params)
}
export const exportUserById = params => {
  return axios.post(`${base}/batch_jobs/export_user_by_id`, params)
}
export const exportUserByPhone = params => {
  return axios.post(`${base}/batch_jobs/export_user_by_phone`, params)
}
export const batchAddUserTagById = params => {
  return axios.post(`${base}/batch_jobs/add_user_tag_by_id`, params)
}
export const batchAddUserTagByPhone = params => {
  return axios.post(`${base}/batch_jobs/add_user_tag_by_phone`, params)
}

export const getNewbieDefineCondApi = params => {
  return axios.get(`${base}/setting/get_newbie_define_condition`, { params })
}

export const setNewbieDefineCondApi = params => {
  return axios.post(`${base}/setting/set_newbie_define_condition`, params)
}

export const getNewbieMissionCfgApi = params => {
  return axios.get(`${base}/setting/get_newbie_mission_cfg`, { params })
}

export const setNewbieMissionCfgApi = params => {
  return axios.post(`${base}/setting/set_newbie_mission_cfg`, params)
}

export const queryRiskUsers = params => {
  return axios.post(`${base}/risk-user/query`, params)
}
export const getRiskUserStats = params => {
  return axios.post(`${base}/risk-user/stats`, params)
}
export const getRiskUserDetail = params => {
  return axios.get(`${base}/risk-user/get_${params.userid}`, params)
}
export const confirmRiskUser = params => {
  return axios.post(`${base}/risk-user/confirm_${params.userid}`, params)
}



// WEBPACK FOOTER //
// ./src/views/users/users.api.js